import { ChevronsUpDownIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/shared/components/ui/button'
import {
	DropdownMenu,
	DropdownMenuCheckboxItem,
	DropdownMenuContent,
	DropdownMenuTrigger,
} from '@/shared/components/ui/dropdown-menu'

import { useAssistantConversation } from '../lib/useAssistantConversation'

export default function ChatAgentSwitcher() {
	const { t } = useTranslation()

	const { agent, avaliableAgents, setAgent } = useAssistantConversation()

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button variant='ghost'>
					{agent?.name
						? t(agent.name, { defaultValue: agent.name })
						: t('app.assistant', { defaultValue: 'AI Assistant' })}
					<ChevronsUpDownIcon className='opacity-50' />
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent>
				{avaliableAgents
					.filter((_agent) => _agent.is_enabled)
					.map((_agent) => (
						<DropdownMenuCheckboxItem
							key={_agent.uri}
							checked={_agent.uri === agent?.uri}
							onCheckedChange={() => {
								setAgent(_agent.uri)
							}}
						>
							{t(_agent.name, { defaultValue: _agent.name })}
						</DropdownMenuCheckboxItem>
					))}
			</DropdownMenuContent>
		</DropdownMenu>
	)
}
